import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import { push, goBack } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export function deleteFavoriteTrip (id) {
  return dispatch => {
    dispatch({type: 'REQUEST_DELETE_FAVE_TRIP', id})
    return ApiHelper
      .deleteFavoriteTrip(id)
      .then(json => {
        dispatch(push(`/account/favorite-trips`))
        return dispatch({ type: 'DELETE_FAVE_TRIP', id })
      })
  }
}

export function updateFavoriteTrip (trip) {
  return (dispatch, getState) => {
    dispatch({type: 'REQUEST_UPDATE_FAVE_TRIP', trip})

    if (trip.purpose=='error') return sleep(1000).then(()=> {
      throw new SubmissionError({
        purpose: 'This place does not exist',
        _error: 'Saving trip failed!'
      })
    })

    return ApiHelper.updateFavoriteTrip(trip)
      .then(json => dispatch({
        type: 'UPDATE_FAVE_TRIP',
        trip,
        favoritePlaces: getState().models.places
     }))
  }
}

export function addFavoriteTrip (trip) {
  return (dispatch, getState) => {
    dispatch({type: 'REQUEST_ADD_FAVE_TRIP', trip})
    return ApiHelper.addFavoriteTrip(trip)
      .then(json => {
        dispatch({
          type:'ADD_FAVE_TRIP',
          trip: json.data,
          receivedAt: Date.now(),
        })
        dispatch(push(`/account/favorite-trips`))
        return json
      }
    )
  }
}

export function listFavoriteTrips() {
  return (dispatch, getState) => {
    dispatch({type: 'REQUEST_FAVE_TRIPS'})
    return ApiHelper.listFavoriteTrips()
      .then(json => dispatch({
        type: 'RECEIVE_FAVE_TRIPS',
        trips: json.data,
        //TODO check if empty and call listFavoritePlaces from here instead?
        favoritePlaces: getState().models.places,
        receivedAt: Date.now(),
      }))
  }
}



// WEBPACK FOOTER //
// ./src/account/favorite-trips/actions.js